export const SUCCESS_TIME = 3 * 1000;
export const ERROR_TIME = 10 * 1000;
